import styled from "styled-components";

export const StyledContainer = styled.main`
    max-width: 1200px;
    margin: auto;
    padding: 20px 20px;
`;